import { render } from "./HammerIcon.vue?vue&type=template&id=13b3efdc"
const script = {}
script.render = render

export default script